<template>
    <div>
        <div class="section-1" :class="{'test-generator-disabled': !testGeneratorEnabled}">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-lg-9">
                        <img class="img-fluid area-label" :src="url + '/' + user + '_area_label.png'" :alt="user + ' area'" :title="user + ' area'"/>
                        <div v-if="(window >= 701) && (window <= 991)">
                            <div v-if="user === 'teachers'" class="mock-test-generator-wrapper-mobile">
                                <a target="_blank" href="https://ecourseplanner.pearson.com.br/" class="mock-test-generator">
                                    <img :src="url + '/btn_ecourse_planner_' + book + '.png'" class="img-fluid active" alt="Mock Test Generator" title="Mock Test Generator"/>
                                </a>
                                <a target="_blank" :href="book + '/test-generator'" class="mock-test-generator" style="margin:0 0 0 auto;">
                                    <img :src="url + '/btn_test_generator_vol' + book + '.png'" class="img-fluid active" alt="Mock Test Generator" title="Mock Test Generator"/>
                                </a>
                            </div>
                            <div v-else>
                                <a target="_blank" :href="book + '/test-generator'" class="mock-test-generator">
                                    <img :src="url + '/btn_mock_test_vol' + book + '.png'" class="img-fluid active" alt="Test Generator" title="Test Generator"/>
                                </a>
                            </div>
                        </div>
                        <div id="videoPlayer" class="video-player">
                            <vimeo :video-url="playing.player_embed_url" :autoplay="autoplay" @ended="videoEnded"></vimeo>
                        </div>
                        <p class="video-label">{{playing.title}}<span>{{playing.duration}}</span></p>
                    </div>
                    <div class="col-12 custom-col-lg">
                        <div class="video-sidemenu">
                            <div class="top">
                                <div v-if="user === 'teachers'" class="teacher">
                                    <a href="https://ecourseplanner.pearson.com.br/" target="_blank" class="mock-test-generator">
                                        <img :src="url + '/btn_ecourse_planner_' + book + '.png'" v-if="user === 'teachers'" class="img-fluid active" alt="Mock Test Generator" title="Mock Test Generator"/>
                                    </a>
                                    <a :href="book + '/test-generator'" target="_blank" class="mock-test-generator" style="margin:0 0 0 auto;">
                                        <img :src="url + '/btn_test_generator_vol' + book + '.png'" v-if="user === 'teachers'" class="img-fluid active" alt="Mock Test Generator" title="Mock Test Generator"/>
                                    </a>
                                </div>
                                <div v-else class="student">
                                    <a :href="book + '/test-generator'" target="_blank" class="mock-test-generator">
                                        <img :src="url + '/btn_mock_test_vol' + book + '.png'" class="img-fluid active" alt="Test Generator" title="Test Generator"/>
                                    </a>
                                </div>
                                <div class="nextAutoplay">
                                    <p>Watch next</p>
                                    <div class="checkbox-wrapper">
                                        <input type="checkbox" id="autoplaySwitch" ref="autoplaySwitch">
                                        <label @click="changeAutoplay" for="autoplaySwitch" class="switch">Autoplay</label>
                                    </div>
                                </div>
                            </div>
                            <div class="video-wrapper">
                                <div class="video col-8 col-md-6 col-lg-12" v-on:click="changeVideo(video)" :key="index" v-for="(video, index) in playlist.slice(0, 3)">
                                    <img :src="video.thumb" class="img-fluid" :alt="video.title" :title="video.title"/>
                                    <p v-if="video.title.length <= 30">{{video.title}}<span>{{video.duration}}</span></p>
                                    <p v-else>{{video.title.slice(0, 30) + "..."}}<span>{{video.duration}}</span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section-2">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-lg-9">
                        <div class="row" style="margin:0; align-items:center;">
                            <div class="search-input">
                                <div class="icon-addon addon-md">
                                    <input name="search" id="search" type="text" class="form-control" v-model="searchQuery" placeholder="Search"/>
                                    <label for="search" class="fa fa-2x fa-search" rel="tooltip" title="search"></label>
                                </div>
                                <p style="margin: 0;"><i class="fa fa-lg fa-question-circle" data-toggle="tooltip" data-trigger="focus"></i></p>
                            </div>
                            <div class="btn-books" v-if="access === 4">
                                <p>Choose a volume:</p>
                                <a href="1">
                                    <img class="img-fluid" :class="{active: book === 1}" :src="book === 1 ? url + '/btn_vol1_on.png' : url + '/btn_vol1_off.png'" alt="Book 1" title="Book 1">
                                </a>
                                <a href="2">
                                    <img class="img-fluid" :class="{active: book === 2}" :src="book === 2 ? url + '/btn_vol2_on.png' : url + '/btn_vol2_off.png'" alt="Book 2" title="Book 2">
                                </a>
                                <a href="3">
                                    <img class="img-fluid" :class="{active: book === 3}" :src="book === 3 ? url + '/btn_vol3_on.png' : url + '/btn_vol3_off.png'" alt="Book 3" title="Book 3">
                                </a>
                            </div>
                        </div>
                        <div id="accordion" class="video-units">
                            <div class="card" v-for="(unit, key, index) in filteredData">
                                <div class="card-header" :class="{show: index === 0}" :id="'unit_' + (index +1)">
                                    <a class="btn" data-toggle="collapse" :data-target="'#collapse_' + index" aria-expanded="false" :aria-controls="'collapse_' + index">
                                        <!--<img class="arrow-up" src=url + "/seta_up.svg" width="20" height="20"/>-->
                                        <svg :class="{arrow_up: index === 0, arrow_down: index !== 0}" xmlns="http://www.w3.org/2000/svg" width="17.318" height="19.355" viewBox="0 0 17.318 19.355">
                                            <g id="Agrupar_373" data-name="Agrupar 373" transform="translate(-340.289 41.356) rotate(-90)">
                                                <path id="Caminho_3316" data-name="Caminho 3316" class="cls-1" d="M69.737,350.563a2.3,2.3,0,0,0,.012-3.219l-.338-.337-2.8-2.8a2.3,2.3,0,0,1,3.247-3.248l6.363,6.364a2.3,2.3,0,0,1,0,3.246l-6.363,6.363a2.3,2.3,0,1,1-3.247-3.246l2.79-2.792Z" transform="translate(-35.541)"/>
                                                <path id="Caminho_3317" data-name="Caminho 3317" class="cls-1" d="M25.8,350.563a2.3,2.3,0,0,0,.012-3.219l-.338-.337-2.8-2.8a2.3,2.3,0,0,1,3.247-3.248l6.363,6.364a2.3,2.3,0,0,1,0,3.246l-6.363,6.363a2.3,2.3,0,1,1-3.247-3.246l2.791-2.792Z" transform="translate(0)"/>
                                            </g>
                                        </svg>
                                        <p v-if="key === 'unit_review'">Review<span class="float-right">{{countVideos[index]}}/{{unit.length}}</span></p>
                                        <p v-else-if="key === 'unit_review_exam'">Exam Review<span class="float-right">{{countVideos[index]}}/{{unit.length}}</span></p>
                                        <p v-else>{{ key.charAt(0).toUpperCase() + key.slice(1).replace("_", " ") }} <span class="float-right">{{countVideos[index]}}/{{unit.length}}</span></p>
                                    </a>
                                </div>

                                <div :id="'collapse_' + index" class="collapse" :class="{show: index === 0}" :aria-labelledby="'heading' + index" data-parent="#accordion">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-8 col-sm-6 col-md-3 col-lg-3 offset-1 offset-sm-1 offset-md-0 offset-lg-0 video" :class="{show_aux: video}" v-for="(video, i) in unit">
                                                <div class="checkbox" v-on:click="changeWatched(key, video)">
                                                    <input type="checkbox" :checked="video.watched">
                                                    <span class="checkmark"></span>
                                                    <span v-if="video.watched" style="font-size:0.7em; position:absolute; top:-3px;">watched</span>
                                                </div>
                                                <div v-on:click="createPlaylist(unit, key, index, i)">
                                                    <img :src="video.thumb" class="img-fluid" :alt="video.title" :title="video.title">
                                                    <p v-if="video.title.length <= 15">{{video.title}}<span class="float-right">{{video.duration}}</span></p>
                                                    <p v-else>{{video.title.slice(0, 15) + "..."}}<span class="float-right">{{video.duration}}</span></p>
                                                </div>
                                            </div>
                                            <div v-if="unit.length === 0">
                                                <p style="padding:20px; color:white;">Sorry, no videos found with requested tags</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-10 col-md-12 offset-1 offset-md-0 custom-col-lg">
                        <h2 class="text-center">See also:</h2>
                        <div v-if="user === 'teachers'" class="mock-test-generator-wrapper">
                            <a v-if="testGeneratorEnabled" href="https://ecourseplanner.pearson.com.br/" target="_blank" class="mock-test-generator">
                                <img :src="url + '/btn_ecourse_planner_' + book + '.png'" class="img-fluid" alt="Mock Test Generator" title="Mock Test Generator"/>
                            </a>
                            <a v-if="testGeneratorEnabled" :href="book + '/test-generator'" target="_blank" class="mock-test-generator">
                                <img :src="url + '/btn_test_generator_vol' + book + '.png'" class="img-fluid" alt="Mock Test Generator" title="Mock Test Generator"/>
                            </a>
                        </div>
                        <div v-else class="mock-test-generator-wrapper">
                            <a v-if="testGeneratorEnabled" :href="book + '/test-generator'" target="_blank" class="mock-test-generator">
                                <img :src="url + '/btn_mock_test_vol' + book + '.png'" class="img-fluid" alt="Test Generator" title="Test Generator"/>
                            </a>
                        </div>
                        <div class="download-area">
                            <h2 class="text-center">Download area</h2>
                            <div>
                                <a :href="book + '/downloads/teachers-guide'" v-if="user === 'teachers'">
                                    <img :src="url + '/btn_teachers_guide_' + book + '.png'" class="img-fluid img-margin" alt="Teachers Guide (in Portuguese)" title="Teachers Guide (in Portuguese)"/>
                                </a>
                                <a v-if="user === 'teachers'" :href="book + '/downloads/active-teach/' + operational_system">
                                    <img :src="url + '/btn_active_teach_' + book + '.png'" class="img-fluid img-margin" alt="Active Teach" title="Active Teach"/>
                                </a>

                                <a :href="book + '/downloads/course-plan'" v-if="user === 'teachers'">
                                    <img :src="url + '/course_plan_vol' + book + '.png'" class="img-fluid img-margin" alt="Course Plan" title="Course Plan"/>
                                </a>
<!--                                <a :href="book + '/downloads/workbook'" v-if="user === 'students'">-->
<!--                                    <img :src="url + '/workbook_label_vol' + book + '.png'" class="img-fluid img-margin" alt="Workbook Answer Key" title="Workbook Answer Key"/>-->
<!--                                </a>-->
                                <a :href="book + '/downloads/audio'">
                                    <img :src="url + '/btn_audio_' + book + '.png'" class="img-fluid img-margin" alt="Audio Content" title="Audio Content"/>
                                </a>
                                <a :href="book + '/downloads/ebook'">
                                    <img :src="url + '/btn_ebook_' + book + '.png'" class="img-fluid img-margin" alt="Ebook Content" title="Ebook Content"/>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    const isUnitReview = (index) => index + 1 === 9;
    const isUnitExamReview = (index) => index + 1 === 10;
    const getUnitKey = (albumIndex) => {
        if(isUnitReview(albumIndex)) {
            return 'unit_review';
        }
        if(isUnitExamReview(albumIndex)) {
            return 'unit_review_exam';
        }

        return "unit_" + (albumIndex + 1);
    };

    const renderVideoDuration = (duration) => {
        let minutes = duration - Math.floor(duration / 60) * 60;

        if(minutes < 10) {
            minutes = "0" + minutes;
        }

        return `${Math.floor(duration / 60)}:${minutes}`;
    };

    export default {
        props: {
            albums: Array,
            user: String,
            book: Number,
            access: Number,
            url: String,
            testGeneratorEnabled: Boolean,
        },
        data: function() {
            return {
                data: {},
                playlist: [],
                playing: {},
                player: null,
                searchQuery: '',
                countVideos: [],
                autoplay: false,
                window: '',
                testGeneratorURL: '',
                operational_system: null
            }
        },
        created: function() {
            window.book = this;
            let context = this;

            this.window = $(window).innerWidth();

            this.testGeneratorURL = this.user === "teachers" ? "http://gerador-avaliacoes-expand.pearson.com.br/professor/api/login/usuario-iframe.php" : "http://gerador-simulados-expand.pearson.com.br/aluno/api/login/usuario-iframe.php";
        },
        mounted: function() {
            this.albums.forEach((album, albumIndex) => {
                let unitKey = getUnitKey(albumIndex);
                this.data[unitKey] = [];

                Object.entries(album).forEach(([key, video]) => {
                    let urlParts = video.uri.split('/');
                    let unit = video['unit'].split(' U', 2);
                    let videoID = urlParts[urlParts.length - 1];

                    this.data[unitKey].push({
                        id: videoID,
                        unit: 'unit_' + unit[1],
                        title: video.name,
	                    player_embed_url: video.player_embed_url,
                        duration: renderVideoDuration(video.duration),
                        thumb: video.pictures.sizes[3].link_with_play_button,
                        watched: sessionStorage.getItem(videoID) || false,
                        tags: video.tags.map((tag) => tag.name),
                    });
                });
            });

            for(let unit in this.data) {
                this.data[unit].forEach((element, index, array) => {
                    this.playlist.push(element);
                });
            }

			this.$nextTick(() => {
				this.playing = this.playlist[0];
				this.playlist.shift();
			})

            this.countVideosWatched();

            setTimeout(function() {
                $(".section-1 .video-sidemenu .mock-test-generator img").removeClass('active');
            }, 7500);

            $("#search").keyup(function() {
                $("#accordion .collapse").removeClass("show");
                $("#accordion .show_aux").parent().parent().parent().addClass("show");
            });

            $("#activeTeach").click(function() {
                document.getElementById('infoModal').classList.add('target');
            });

            this.operational_system = navigator.platform;

        },
        updated: function() {
            $("#accordion .card-header").click(function() {
                if($(this).parent('.card').siblings('.card').children('.card-header').hasClass('show')){
                    $(this).parent('.card').siblings('.card').children('.card-header.show').find("svg").toggleClass('arrow_up arrow_down');
                    $(this).parent('.card').siblings('.card').children('.card-header').removeClass('show');
                }
                $(this).toggleClass('show');
                $(this).find("svg").toggleClass('arrow_up arrow_down');
            });

            $('.search-input p').tooltip({
                placement: 'right',
                title: 'Pesquise por uma ou mais palavras-chave.'
            });
        },
        methods: {
            changeVideo: function(video) {
                let context = this;
                this.playing = video;

                this.playlist.forEach(function(element, index, array){
                    if(element.id === video.id) context.playlist = context.playlist.slice(index + 1);
                });

                window.scrollTo(0, $("videoPlayer").offset.top);
            },
            changeAutoplay: function() {
                let autoplaySwitch = $("#autoplaySwitch");

                if(autoplaySwitch.attr('checked') === 'checked') {
                    autoplaySwitch.removeAttr('checked');
                    autoplaySwitch.removeClass('checked');
                } else {
                    autoplaySwitch.attr('checked', 'checked');
                    autoplaySwitch.addClass('checked');
                }

                this.autoplay = !this.autoplay;

            },

            changeWatched: function(key, video) {
                video.watched = !video.watched;
                sessionStorage.setItem(key + " : " + video.id, JSON.stringify(video));
                this.countVideosWatched();
            },

            countVideosWatched: function() {
                let context = this;
                context.countVideos = [];
                for(let unit in this.data) {
                    let aux = 0;
                    context.data[unit].forEach(function(element, index, array) {
                        let video = JSON.parse(sessionStorage.getItem(unit + " : " + element.id));

                        if(video) element.watched = video.watched;
                        if(element.watched === true) aux++;
                    });
                    context.countVideos.push(aux);
                }
            },
            videoEnded: function(){
                this.changeWatched(this.playing.unit, this.playing);

                this.playing = this.playlist[0];
                this.playlist.shift();
            },
            createPlaylist: function(unit, key, index, i) {
                let data = this.data;
                let context = this;

                this.playing = unit[i];
                console.log(unit, key, index, i);
                if(this.searchQuery.length >= 4) {
                    data = this.filteredData;
                    context.playlist = [];
                    for(let z in data) {
                        data[z].forEach((x, w, y) =>  {
                            if(context.playing.unit.match(/\d+/)[0] <= z.match(/\d+/)[0] && context.playing.id !== x.id) {
                                context.playlist.push(x);
                            }
                        });
                    }
                } else {
                    data = Object.keys(data).reduce((object, j) => {
                        if(j > key) object[j] = data[j];
                        return object;
                    }, {});

                    unit = unit.slice(i + 1);
                    this.playlist = unit;

                    for(let aux in data) {
                        data[aux].forEach((element, index, array) => {
                            this.playlist.push(element);
                        });
                    }
                }

                window.scrollTo(0, $("videoPlayer").offset.top);
            },
            testGenerator: function() {
                $("#testGenerator").submit();
            }
        },
        computed: {
            filteredData: function () {
                let filterKey = this.searchQuery && this.searchQuery.toLowerCase();
                let data = this.data;
                let obj = {};

                for(let unit in data) {
                    obj[unit] = [];
                }

                if(filterKey.length > 3) {
                    let aux = filterKey.trim().split(" ");
                    aux.forEach((e, i, a) => {
                        for(let unit in data) {
                            data[unit].filter(function(element, index, array) {
                                if(element.tags.some(res => res.toLowerCase().includes(e)) === true) {
                                    if(obj[unit].length !== 0) {
                                        if(obj[unit].some(ele => ele.id === element.id) === false) obj[unit].push(element);
                                    } else {
                                        obj[unit].push(element);
                                    }
                                }
                            });
                        }
                    });
                    data = obj;
                }
                return data;
            },
        },
        filters: {
            capitalize: function(str) {
                return str.charAt(0).toUpperCase() + str.slice(1);
            }
        },
    }
</script>
